import {
  ListItem,
  Paper,
  Stack,
  Box,
  Typography,
  Grid,
  Link,
} from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { paginateArray } from "../helpers/paginateArray";
import UserControl from "../Dialogs/UserControl";
dayjs.extend(relativeTime);

export default function ChecklistTemplateCard(props) {
  return (
    <div>
      {paginateArray(props.checklists, props.page, props.rowsPerPage).map(
        (obs, idx) => (
          <ListItem key={idx} style={{ padding: 0 }}>
            <Paper
              elevation={6}
              style={{ width: "100%", marginTop: 10, marginBottom: 10 }}
            >
              <div style={{ padding: 20 }}>
                <Stack>
                  <Box
                    sx={{
                      width: "100%",
                      height: 10,
                      borderRadius: 1,
                      bgcolor: obs.Selected
                        ? "primary.main"
                        : "secondary.light",
                    }}
                  />
                  <Grid container spacing={0}>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Link
                          variant="h6"
                          gutterBottom
                          underline="hover"
                          href={`/project/${props.projectId}/checklist-templates/${obs.id}/edit`}
                          color="secondary.main"
                        >{`Name: ${obs["Name"]}`}</Link>
                      </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Checklist Type:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs["Type"]}`}</Typography>
                      </Stack>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          color="secondary.light"
                        >{`Total Rows:`}</Typography>
                        <Typography
                          style={{ marginLeft: 6 }}
                        >{`${obs.rows.length}`}</Typography>
                      </Stack>
                    </Grid>
                    <Grid
                      sx={{
                        display: {
                          xs: "none",
                          sm: "none",
                          md: "none",
                          lg: "block",
                        },
                      }}
                      size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    />

                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <UserControl
                        isCreator={true}
                        user={obs["Created By"].toString()}
                        uid={
                          obs["Creator UID"]
                            ? obs["Creator UID"]
                            : obs["Created By"]
                        }
                      />
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          gutterBottom
                          color="secondary.light"
                        >{`Created Date:`}</Typography>
                        <Typography
                          style={{ marginLeft: 4 }}
                          variant="caption"
                          gutterBottom
                        >
                          {`${new Date(
                            obs["Created Date"].seconds * 1000,
                          ).toLocaleDateString()}
              
                 (${dayjs(
                   new Date(obs["Created Date"].seconds * 1000),
                 ).fromNow()})`}
                        </Typography>
                      </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                      <UserControl
                        isCreator={false}
                        user={obs["Modified By"].toString()}
                        uid={
                          obs["Modifier UID"]
                            ? obs["Modifier UID"]
                            : obs["Modified By"]
                        }
                      />
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="caption"
                          gutterBottom
                          color="secondary.light"
                        >{`Modified Date:`}</Typography>
                        <Typography
                          style={{ marginLeft: 4 }}
                          variant="caption"
                          gutterBottom
                        >
                          {`${new Date(
                            obs["Modified Date"].seconds * 1000,
                          ).toLocaleDateString()}  (${dayjs(
                            new Date(obs["Modified Date"].seconds * 1000),
                          ).fromNow()})`}
                        </Typography>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </div>
            </Paper>
          </ListItem>
        ),
      )}
    </div>
  );
}
